import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const navLinks = [
    { path: '/', label: 'Anasayfa' },
    { path: '/hakkimizda', label: 'Hakkımızda' },
    { path: '/hizmetler', label: 'Hizmetler' },
    { path: '/blog', label: 'Blog' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'shadow-sm' : ''}`} style={{ backgroundColor: isScrolled ? '#f4f1ec' : 'rgba(244, 241, 236, 0.97)' }}>
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/f860490af8fb2afe82f5ccd4e5e3f508.png"
              alt="İzmir Tente Tamir Logo"
              className="h-[90px] md:h-[108px] w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-gray-900 border-b-2 border-green-500'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center space-x-3">
            <a
              href="tel:+905513723512"
              className="flex items-center space-x-2 text-sm font-medium text-gray-800 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-base"></i>
              <span>0551 372 35 12</span>
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-800 cursor-pointer"
            aria-label="Menü"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden border-t border-stone-200" style={{ backgroundColor: '#f4f1ec' }}>
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-2 text-sm font-medium cursor-pointer ${
                  location.pathname === link.path ? 'text-gray-900' : 'text-gray-600'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:+905513723512"
              className="flex items-center space-x-2 py-2 text-sm font-medium text-gray-800 cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              <span>0551 372 35 12</span>
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
